@if (contentType === 'string') {
  <div [innerHTML]="getStringContent()"></div>
}
@if (contentType === 'template') {
  <ng-container *ngTemplateOutlet="getTemplateContent(); context: context"></ng-container>
}
